import React, { useLayoutEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import SunbaeBriefingBranchPc from './designcomponents/sunbaebriefingbranchpc';
import SunbaeBriefingBranchMobile from './designcomponents/sunbaebriefingbranchmobile';
import { GIMPO_CONFIG } from '../lib/briefingBranchConfig';

export default function SunbaeBriefingGimpo() {
  useLayoutEffect(() => { window.scrollTo(0, 0); }, []);
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });
  return isMobile
    ? <SunbaeBriefingBranchMobile config={GIMPO_CONFIG} />
    : <SunbaeBriefingBranchPc config={GIMPO_CONFIG} />;
}
